import { render, staticRenderFns } from "./SubmitWorkerAction.vue?vue&type=template&id=4d5c989e&scoped=true&"
import script from "./SubmitWorkerAction.vue?vue&type=script&lang=js&"
export * from "./SubmitWorkerAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5c989e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
